import { defineComponent as _defineComponent } from 'vue'
import WizardStep from '../wizard/WizardStep.vue';
import AlertsOperatorsSelect from '@/components/inputs/AlertsOperatorsSelect.vue';
import AlertsMetricsSelect from '@/components/inputs/AlertsMetricsSelect.vue';
import { isEmpty, valueOrDefault } from '@/utils/misc';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { translateFilterTimeAxisSpanEnum } from '@/utils/i18n';
import { translateUnit } from '@/utils/number';
import { ConsoleEnum } from '@/models/enums/ConsoleEnum';
import { values } from '@/utils/enum';
import { computed } from 'vue';
import { KpiSelectionFormData } from './model';
import { AlertKPI, AlertOperator, CareAlertMetric } from '@/models/enums/AlertsEnums';
import useVuelidate from '@vuelidate/core';
import { numeric, required } from '@/utils/validation';
import { helpers } from '@vuelidate/validators';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'KpiSelectionFormWizardStep',
  props: {
    value: null,
    title: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: KpiSelectionFormData) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: KpiSelectionFormData;
  title?: string;
};

const { t } = useI18n();





const formData = computed<KpiSelectionFormData>({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

const validations = {
  alert: {
    kpi: {
      required: helpers.withMessage(
        () => t('form.select_validation').toString(),
        (value: AlertKPI<CareAlertMetric>) =>
          value.kpi !== CareAlertMetric.None,
      ),
    },
    operator: {
      required: helpers.withMessage(
        () => t('form.select_validation').toString(),
        (value: AlertOperator) => value !== AlertOperator.None,
      ),
    },
    threshold: {
      required,
      numeric,
    },
    dateGrouping: {
      required: helpers.withMessage(
        () => t('form.select_validation').toString(),
        (value: FilterTimeAxisSpanEnum) =>
          value !== FilterTimeAxisSpanEnum.None,
      ),
    },
  },
};
const v$ = useVuelidate(validations, { alert: formData });

// Because Hour is represented with a 6, values() puts it in the last place of the list.
// This forces it to show up on top
const dateGroupingOptions = [
  FilterTimeAxisSpanEnum.Hour,
  ...values(FilterTimeAxisSpanEnum).filter(
    (x) =>
      ![FilterTimeAxisSpanEnum.None, FilterTimeAxisSpanEnum.Hour].includes(x),
  ),
];

function updateField(field: keyof KpiSelectionFormData, value: any) {
  formData.value = { ...formData.value, [field]: value };
}

function getValidationMessage(key: keyof KpiSelectionFormData) {
  return v$.value.alert[key]?.$errors[0]?.$message;
}

const kpiUnit = computed<string>(() =>
  translateUnit(formData.value.kpi?.unit ?? null, null),
);

return { __sfc: true,t, props, emit, formData, validations, v$, dateGroupingOptions, updateField, getValidationMessage, kpiUnit, WizardStep, AlertsOperatorsSelect, AlertsMetricsSelect, isEmpty, valueOrDefault, translateFilterTimeAxisSpanEnum, ConsoleEnum }
}

})